import { Component } from '@angular/core';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';

@Component({
    selector: 'app-navigation',
    imports: [ToolbarComponent, SideMenuComponent],
    templateUrl: './navigation.component.html',
    styleUrl: './navigation.component.scss'
})
export class NavigationComponent {
  public showSideMenu = false;
}
